<template>
  <div id="wallpaper">
    <Navbar />
    <v-container class="">
      <v-card
        :loading="!(projects.length > 0)"
        width="500"
        outlined
        text
        max-height="350"
      >
        <v-subheader>Proyectos</v-subheader>
        <v-divider></v-divider>
        <!-- <v-card-content>
          <v-list dense flat mandatory class="projects-list">
            <template v-for="(p, index) in projects">
              <v-list-item-group dense :key="index">
                <v-list-item @click="loadProject(p)">
                  <v-list-item-icon>
                    <v-icon>mdi-office-building</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    {{ p.name }}
                    <small v-if="!p.image">[Sin logo]</small>
                  </v-list-item-content>
                </v-list-item>
                <v-divider v-if="index < (projects.length - 1)"></v-divider>
              </v-list-item-group>
            </template>
          </v-list>
        </v-card-content>-->
        <section color="#FFF">
          <div>
            <v-chip class="ma-2" dark color="#27ae60" link v-for="(p, index) in projects" :key="index" @click="loadProject(p)">
              <v-avatar left>
                <v-icon>mdi-office-building</v-icon>
              </v-avatar>
              {{ p.name }}
            </v-chip>
          </div>
        </section>
      </v-card>
    </v-container>
  </div>
</template>
<script>
import Vue from "vue";
import { Auth } from "../../classes/Auth";
import axios from "axios";
import Navbar from "./partials/Navbar.vue";
import { API } from "../../globals";
import { apiv1 } from "../../libs/apiv1";

const auth = new Auth();

export default Vue.extend({
  name: "ChooseProject",
  data: () => ({
    selected: null,
    projects: []
  }),
  components: {
    Navbar
  },
  mounted() {
    this.selectProjects();
  },
  methods: {
    selectProjects: async function() {
      let url = `/user/projects?user=${auth.getUser().id}`;
      if (auth.getUser().issuperadmin) {
        url = `/user/projects`;
      }
      await apiv1({
        method: "GET",
        url: url
      }).then(res => {
       this.projects = res.data})
       .catch(e => {console.log(e+'error')})
    },
    loadProject: function(p) {
      if (p) {
        auth.setProject(p);
        this.$awn.info(`Proyecto ${p.name}, cargado correctamente!`);
        this.$router.push("/smartchronos/dashboard2");
      }
    }
  }
});
</script>
<style lang="scss" scoped>
#wallpaper {
  background: url("~@/assets/Energy-Efficient-Light-Bulbs.jpg");
  position: fixed;
  top: 50px;
  left: 0;
  width: 100%;
  height: calc(100% - 50px);
  background-size: cover;
}

.container {
  height: 100vh;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;

}
.v-card {
  // overflow-y: auto;
  overflow: hidden;
}


</style>